import type { Mission } from '../missions.ts'

export const cfpb: Mission = {
  id: "cfpb",
  name: "Consumer Financial Protection Bureau",
  short: "CFPB",
  call: "Consumers",
  kind: "independent",
  community: "financial",
  url: "https://www.consumerfinance.gov/",
  established: 2010,
  palette: {
    primary: "#20aa3f",
    secondary: "#254b87",
    accent: "#ff9e1b",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://cfpb.github.io/design-system/foundation/color",
  },
  motif: "eagle",
  mission: {
    text: "The CFPB works to create and support innovative and resilient consumer financial markets where consumers can choose the products and services that meet their individual needs.",
    url: "https://www.consumerfinance.gov/about-us/the-bureau/",
  },
  fact: {
    text: "The CFPB was created to give one agency accountability for enforcing federal consumer financial laws, once split among several agencies.",
    url: "https://www.consumerfinance.gov/about-us/the-bureau/",
  },
  seal: {
    file: "public/seals/cfpb.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Consumer_Financial_Protection_Bureau.svg",
  },
  logo: {
    file: "public/logos/cfpb.svg",
    source: "https://commons.wikimedia.org/wiki/File:CFPB_logo.svg",
  },
  identifier: {
    about: "https://www.consumerfinance.gov/about-us/",
    accessibility: "https://www.consumerfinance.gov/accessibility/",
    foia: "https://www.consumerfinance.gov/foia-requests/",
    noFear: "https://www.consumerfinance.gov/office-civil-rights/no-fear-act-cummings-act/",
    oig: "https://oig.federalreserve.gov/",
    performance: "https://files.consumerfinance.gov/f/documents/cfpb_strategic-plan_fy2026-fy2030.pdf",
    privacy: "https://www.consumerfinance.gov/privacy/website-privacy-policy/",
  },
  media: {
    photos: [
      {
        file: "/media/cfpb-call-center.jpg",
        small: "/media/cfpb-call-center-sm.jpg",
        alt: "Rows of office cubicles where staff take consumer complaint calls, seen from above",
        title: "Coralville, IA: Consumer Response Call Center",
        creator: "Consumer Financial Protection Bureau",
        source: "https://commons.wikimedia.org/wiki/File:Coralville,_IA_Consumer_Response_Call_Center_(8620101136).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/cfpb-pie-town.jpg",
        small: "/media/cfpb-pie-town-sm.jpg",
        alt: "Weathered general merchandise store fronts along a dirt main street in Pie Town, New Mexico",
        title: "General Merchandise store, Main Street, Pie Town, New Mexico",
        creator: "Russell Lee, Farm Security Administration",
        source: "https://www.loc.gov/pictures/item/2017877751/",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
